var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiquidationFee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#DF3030",
    strokeWidth: 2,
    d: "M9 18.5c0-.94.291-2.083.818-3.392.523-1.3 1.248-2.692 2.053-4.116.51-.902 1.06-1.828 1.604-2.745.726-1.224 1.444-2.433 2.049-3.553.725 1.323 1.5 2.628 2.245 3.882.614 1.033 1.206 2.03 1.733 2.974C21.005 14.242 22 16.537 22 18.5c0 3.156-1.325 4.848-2.742 5.793-1.483.989-3.15 1.207-3.758 1.207-.548 0-2.222-.314-3.737-1.38C10.306 23.094 9 21.383 9 18.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F1A7A7",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M24 5h4M12.5 17l1.5-3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquidationFee);
export default __webpack_public_path__ + "static/media/liquidationFee.d6a1cf8e2f937f3923584bb3c0ac5e3a.svg";
export { ForwardRef as ReactComponent };